module.exports = "<div class=\"toast align-items-center border-0\" [ngClass]=\"{'show':show,'text-bg-success':issuccess,'text-bg-danger':!issuccess}\" id=\"invoice-tostater\" role=\"alert\" aria-live=\"assertive\" aria-atomic=\"true\" data-bs-delay=\"2000\" data-autohide=\"true\" style=\"position: fixed;top: 100px;right: 0;z-index:166001\">\r\n    <div class=\"d-flex\">\r\n        <div class=\"toast-body\" id=\"invoice-tostater-message\">\r\n         {{Message}}\r\n        </div>\r\n        \r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/QrMena/components/toaster/toaste.html
// module id = ./src/QrMena/components/toaster/toaste.html
// module chunks = main